/**
 * Thrown when optimistic concurrency refuses an update (spec 0045).
 * Expected outcome of a stale save — not a programming failure.
 *
 * `expected` / `current` are optional: the server-side compare-and-set path
 * (request 0247) does not return the versions that mismatched. The user-facing
 * message does not use these numbers.
 */
export class ConcurrentModificationException extends Error {
    constructor(expected, current) {
        super('Este registro foi alterado por outra pessoa depois que você o abriu. Recarregue para ver a versão atual e refaça a sua alteração.');
        this.expected = expected;
        this.current = current;
        this.name = 'ConcurrentModificationException';
    }
}
//# sourceMappingURL=concurrentModificationException.js.map